export const SET_USER = "setUser";
export const SET_USER_MUTATION = "setUserMutation";
export const SET_LOADING = "setLoading";
export const SET_LOADING_MUTATION = "setLoadingMutation";
export const SET_REGIST_DATA = "setRegistrationData";
export const GET_REGIST_DATA = "getRegistrationData";
export const SET_REGIST_DATA_MUTATION = "setRegistrationData"
export default {
  namespaced: true,
  state: {
    userInfo: {},
    isLoading: false,
    popupAccountDeActive: false,
  },
  state: () => ({
    userInfo: {},
    isLoading: false,
    popupAccountDeActive: false,
    registrationData: {},
  }),


  actions: {
    [SET_USER](context, payload) {
      context.commit(SET_USER_MUTATION, payload);
    },

    [SET_LOADING](context, payload) {
      context.commit(SET_LOADING_MUTATION, payload);
    },
    [SET_REGIST_DATA](context, payload) {
      context.commit(SET_REGIST_DATA_MUTATION, payload);

    }
  },
  getters: {
    [GET_REGIST_DATA]: (state) => state.registrationData,
    ekycStatus: (state) => {
      state.userInfo?.is_ekyc || null}
    },
  mutations: {
    [SET_USER_MUTATION](state, payload) {
      state.userInfo = payload;
    },

    [SET_LOADING_MUTATION](state, payload = false) {
      state.isLoading = payload;
    },
    [SET_REGIST_DATA_MUTATION](state, payload) {
      console.log('iswork')
      state.registrationData = payload;

    },
    setPopupAccountDeActive(state, payload) {
      state.popupAccountDeActive = payload;
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/authUserModule.js